/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

const baseUrl = 'navconfig';
const pathParameterPlaceholder = undefined;
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/navconfig/v5/navconfig/searchable-items
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:NavConfigResourceV5+type:symbol+getAllSearchableItems&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Nav_Config_V5-get-%2Fnavconfig%2Fv5%2Fnavconfig%2Fsearchable-items'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fnavconfig%2Fv5%2Fnavconfig%2Fsearchable-items?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getAllSearchableItemsRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v5/navconfig/searchable-items'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/navconfig/v5/internal/navconfig/searchable-items/portal-id/{portalId}/user-id/{userId}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: internal ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:NavConfigInternalResourceV5+type:symbol+getAllSearchableItems&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Nav_Config_Internal_V5-get-%2Fnavconfig%2Fv5%2Finternal%2Fnavconfig%2Fsearchable-items%2Fportal-id%2F%7BportalId%7D%2Fuser-id%2F%7BuserId%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fnavconfig%2Fv5%2Finternal%2Fnavconfig%2Fsearchable-items%2Fportal-id%2F%28%28%7BportalId%7D%29%29%2Fuser-id%2F%28%28%7BuserId%7D%29%29?showRequestDetails=true&body=&authType=internal)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getAllSearchableItemsInternalRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v5/internal/navconfig/searchable-items/portal-id', pathParameterPlaceholder, 'user-id', pathParameterPlaceholder]),
  pathParameters: freeze(['portalId', 'userId'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/navconfig/v5/navconfig
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:NavConfigResourceV5+type:symbol+getAppNav&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Nav_Config_V5-get-%2Fnavconfig%2Fv5%2Fnavconfig'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fnavconfig%2Fv5%2Fnavconfig?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getAppNavRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v5/navconfig'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/navconfig/v5/internal/navconfig/portal-id/{portalId}/user-id/{userId}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: internal ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:NavConfigInternalResourceV5+type:symbol+getAppNav&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Nav_Config_Internal_V5-get-%2Fnavconfig%2Fv5%2Finternal%2Fnavconfig%2Fportal-id%2F%7BportalId%7D%2Fuser-id%2F%7BuserId%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fnavconfig%2Fv5%2Finternal%2Fnavconfig%2Fportal-id%2F%28%28%7BportalId%7D%29%29%2Fuser-id%2F%28%28%7BuserId%7D%29%29?showRequestDetails=true&body=&authType=internal)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getAppNavInternalRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v5/internal/navconfig/portal-id', pathParameterPlaceholder, 'user-id', pathParameterPlaceholder]),
  pathParameters: freeze(['portalId', 'userId'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/navconfig/v5/navconfig/hubless
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:NavConfigResourceV5+type:symbol+getHubLess&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Nav_Config_V5-get-%2Fnavconfig%2Fv5%2Fnavconfig%2Fhubless'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fnavconfig%2Fv5%2Fnavconfig%2Fhubless?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getHubLessRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v5/navconfig/hubless'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/navconfig/v5/navconfig/portal-details
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:NavConfigResourceV5+type:symbol+getNavPortal&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Nav_Config_V5-get-%2Fnavconfig%2Fv5%2Fnavconfig%2Fportal-details'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fnavconfig%2Fv5%2Fnavconfig%2Fportal-details?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getNavPortalRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v5/navconfig/portal-details'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/navconfig/v5/navconfig/settings
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:NavConfigResourceV5+type:symbol+getSettingsNav&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Nav_Config_V5-get-%2Fnavconfig%2Fv5%2Fnavconfig%2Fsettings'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fnavconfig%2Fv5%2Fnavconfig%2Fsettings?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getSettingsNavRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v5/navconfig/settings'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/navconfig/v5/internal/navconfig/settings/portal-id/{portalId}/user-id/{userId}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: internal ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:NavConfigInternalResourceV5+type:symbol+getSettingsNav&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Nav_Config_Internal_V5-get-%2Fnavconfig%2Fv5%2Finternal%2Fnavconfig%2Fsettings%2Fportal-id%2F%7BportalId%7D%2Fuser-id%2F%7BuserId%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fnavconfig%2Fv5%2Finternal%2Fnavconfig%2Fsettings%2Fportal-id%2F%28%28%7BportalId%7D%29%29%2Fuser-id%2F%28%28%7BuserId%7D%29%29?showRequestDetails=true&body=&authType=internal)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getSettingsNavInternalRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v5/internal/navconfig/settings/portal-id', pathParameterPlaceholder, 'user-id', pathParameterPlaceholder]),
  pathParameters: freeze(['portalId', 'userId'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/navconfig/v5/navconfig/settings-preferences
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:NavConfigResourceV5+type:symbol+getSettingsPreferencesNav&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Nav_Config_V5-get-%2Fnavconfig%2Fv5%2Fnavconfig%2Fsettings-preferences'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fnavconfig%2Fv5%2Fnavconfig%2Fsettings-preferences?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getSettingsPreferencesNavRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v5/navconfig/settings-preferences'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * delete-/navconfig/v5/navconfig/cache
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:NavConfigResourceV5+type:symbol+invalidateCache&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Nav_Config_V5-delete-%2Fnavconfig%2Fv5%2Fnavconfig%2Fcache'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/delete/api.hubapi.com%2Fnavconfig%2Fv5%2Fnavconfig%2Fcache?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const invalidateCacheRpc = freeze({
  baseUrl,
  method: 'delete',
  pathSegments: freeze(['v5/navconfig/cache'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * delete-/navconfig/v5/internal/navconfig/cache/portal-id/{portalId}/user-id/{userId}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: internal ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:NavConfigInternalResourceV5+type:symbol+invalidateCache&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Nav_Config_Internal_V5-delete-%2Fnavconfig%2Fv5%2Finternal%2Fnavconfig%2Fcache%2Fportal-id%2F%7BportalId%7D%2Fuser-id%2F%7BuserId%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/delete/api.hubapi.com%2Fnavconfig%2Fv5%2Finternal%2Fnavconfig%2Fcache%2Fportal-id%2F%28%28%7BportalId%7D%29%29%2Fuser-id%2F%28%28%7BuserId%7D%29%29?showRequestDetails=true&body=&authType=internal)</span></span><span style='padding-left: 12px'></span></span>
 */
export const invalidateCacheInternalRpc = freeze({
  baseUrl,
  method: 'delete',
  pathSegments: freeze(['v5/internal/navconfig/cache/portal-id', pathParameterPlaceholder, 'user-id', pathParameterPlaceholder]),
  pathParameters: freeze(['portalId', 'userId'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * delete-/navconfig/v5/navconfig/settings-cache
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:NavConfigResourceV5+type:symbol+invalidateSettingsCache&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Nav_Config_V5-delete-%2Fnavconfig%2Fv5%2Fnavconfig%2Fsettings-cache'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/delete/api.hubapi.com%2Fnavconfig%2Fv5%2Fnavconfig%2Fsettings-cache?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const invalidateSettingsCacheRpc = freeze({
  baseUrl,
  method: 'delete',
  pathSegments: freeze(['v5/navconfig/settings-cache'])
});